import React from "react";
import "../Procedures/checkbox.css";
import { FaRegEdit } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { Table, ADHImage } from "../../style/Prescription";
import { Button, ButtonGrey } from "../../style/Button";
import { Grid, MenuItem, Paper, Select } from "@material-ui/core";
import moment from "moment";
import { CustomDiv } from "../../style/shared";
import HADV from "../../assets/Ads/Horizontal2.jpeg";
import Medication from "../Prescription/Medication";
import TitlDollar from "../../assets/tiltdollar.png";
import TitlDollarGrey from "../../assets/dollargrey_tilt.png";
import { Image2 } from "../../style/Logo";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import PropTypes from "prop-types";
import { withStyles, styled } from "@material-ui/styles";
import { Autorenew } from "@material-ui/icons";
import "./Bill.css";
import "../Prescription/Prescription.css";
function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  return {
    margin: "15% auto",
    color: "white",
    textAlign: "center",
    padding: "25px 10px",
    width: "500px",
    height: "auto",
    backgroundColor: "#4678EB",
    border: "0px solid #000",
    borderRadius: "18px",
    padding: "20px 20px"
  };
}

const useStyles = (theme) => ({
  paperr: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
});

export class Pharmacy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      medarray: [],
      name: "",
      isOpen: false,
      modalStyle: getModalStyle(),
    };

    this.restoreRows = this.restoreRows.bind(this);
    this.handleCallback = this.handleCallback.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.restoreRows();
  }

  handleOpen = () => {
    this.setState({
      isOpen: true,
    });
  };

  handleClose = () => {
    this.setState({
      isOpen: false,
    });
    window.sessionStorage.removeItem("med");
    window.sessionStorage.removeItem("keyselected");
    window.sessionStorage.removeItem("valuearr");
    window.sessionStorage.removeItem("usersession");
    window.sessionStorage.removeItem("medarray");
    this.props.history.push({
      pathname: "/",
    });
  };

  handleCallback = (childData) => {
    this.state.name = childData;
    this.handleOpen();
    this.forceUpdate();
  };

  restoreRows = () => {
    let rowstring = window.sessionStorage.getItem("medarray");
    if (rowstring) {
      this.state.medarray = JSON.parse(rowstring);
    }
    if (this.state.medarray.length > 0) {
      this.state.medarray.forEach((element) => {
        this.createRows(element);
      });
    }
  };

  createRows = (valuem) => {
    var logotag = "";
    if (valuem.discount) {
      logotag = <Image2 src={TitlDollar} alt="logo" />;
    } else {
      logotag = <Image2 src={TitlDollarGrey} alt="logo" />;
    }
    this.state.rows.push(
      <React.Fragment>
        <tr>
          <td
            style={{
              padding: "30px 0px 10px 10px",
              marginRight: "0px",
              minWidth: "20px",
              fontSize: "14.13px"
            }}
          >
            <div class="form-check mt-1 ms-5" style={{ padding: "0px" }}>
              <input
                class="form-check-input p-2"
                type="checkbox"
                value=""
                checked={true}
              />
              <label for="" class="text-secondary ms-3 theme-font"></label>
            </div>
          </td>
          <td
            style={{
              textAlign: "left",
              padding: "30px 0px 10px 10px",
              fontWeight: 400,
              fontSize: "14.13px"
            }}
          >
            {moment().format("DD-MMM-YYYY")}
          </td>
          <td
            className="pharmacy-med-name"
            style={{
              maxWidth: "227px",
              fontWeight: 400,
              fontSize: "14.13px"
            }}
          >
            {valuem.medicationName} {logotag}
            <br />
            <span
              style={{
                color: "grey",
                fontWeight: 500,
                fontSize: "14.13px",
                color: "#969696",
              }}
            >
              <b
                style={{
                  color: "#606060",
                  fontWeight: 600,
                  fontSize: "14.13px",
                  fontFamily:
                    "work sans",
                }}
              >
                Sig:
              </b>{" "}
              {valuem.dosageForm} {valuem.route} {valuem.frequency} <br />
              <b
                style={{
                  color: "#606060",
                  fontWeight: 600,
                  fontSize: "14.13px",
                  fontFamily:
                    "work sans",
                }}
              >
                Pharm Note:
              </b>{" "}
              {valuem.pharmacyNote} <br />
              QUES: 800-422-4523
            </span>
          </td>
          <td style={{ padding: "30px 0px 10px 10px", fontWeight: 500 }}>
            {valuem.amount}
          </td>
          <td
            style={{
              padding: "30px 0px 10px 10px",
              textAlign: "center",
              fontWeight: 500,
            }}
          >
            0
          </td>
          <td style={{ padding: "30px 0px 10px 10px", textAlign: "center" }}>
            <div class="form-check mt-1 ms-5" style={{ padding: "0px" }}>
              <div style={{ marginLeft: "20px" }}>
                <input class="form-check-input p-2" type="checkbox" value="" />
              </div>
            </div>
          </td>
        </tr>
      </React.Fragment>
    );
  };

  render() {
    const { classes } = this.props;

    return (
      <div className="pharmacy-page" style={{ maxWidth: "100%" }}>
        <Grid container className={`pharmacySection ${this.props.verticalCreative ? "" : "noCreative"}`}>
          <Grid item lg={`${this.props.verticalCreative ? 9 : 12}`} md={12} xs={12}>
            <div className="parmacyBilling">
              <section
                class="mt-3 custom-radius border border-secondary"
                style={{ width: "100%", backgroundColor: "white" }}
              >
                <nav class="navbar navbar-expand-lg  custom-radius  navbar-dark theme-color p-0">
                  <a
                    class="navbar-brand  ms-4 fw-bold"
                    href="#"
                    style={{ fontSize: "12px" }}
                  >
                    <br></br>
                  </a>
                </nav>
                <div style={{ padding: "20px", backgroundColor: "white" }}>
                  <Grid container spacing={1}>
                    <Grid item lg={1}>
                      <span
                        style={{
                          fontSize: "14.13px",
                          fontWeight: 600,
                          color: "#58595B",
                          fontFamily:
                            "work sans",
                        }}
                      >
                        Pharmacy:
                      </span>
                    </Grid>
                    <Grid item lg={3}>
                      <div style={{ maxWidth: "100%", minWidth: "100%" }}>
                        <Select
                          defaultValue="0"
                          style={{
                            minWidth: "90%",
                            fontWeight: 600,
                            border: "1px solid lightgrey",
                            borderRadius: "5px",
                            padding: "2px 10px 2px 10px",
                            fontSize: "12px",
                            color: "#58595B",
                            fontFamily:
                              "work sans",
                          }}
                        >
                          <MenuItem value="0" selected={true}>
                            A Pharmacy 10.6MU
                          </MenuItem>
                        </Select>
                      </div>
                    </Grid>
                    <Grid item lg={2}>
                      <span
                        style={{
                          fontSize: "14.13px",
                          fontWeight: 600,
                          color: "#4678ED",
                        }}
                      >
                        Find a Pharmacy 
                      </span>
                    </Grid>
                    <Grid item lg={1}>
                      <span
                        style={{
                          fontSize: "14.13px",
                          fontWeight: 600,
                          color: "#58595B",
                          fontFamily:
                            "work sans",
                        }}
                      >
                        Phone:
                      </span>
                    </Grid>
                    <Grid item lg={2}>
                      <span
                        style={{
                          fontSize: "14.13px",
                          fontWeight: 600,
                          color: "#58595B",
                          fontFamily:
                            "work sans",
                        }}
                      >
                        703-205-7034
                      </span>
                    </Grid>
                    <Grid item lg={1}>
                      <span
                        style={{
                          fontSize: "14.13px",
                          fontWeight: 600,
                          color: "#58595B",
                          fontFamily:
                            "work sans",
                        }}
                      >
                        ERx:
                      </span>
                    </Grid>
                    <Grid item lg={2}>
                      <span
                        style={{
                          fontSize: "14.13px",
                          fontWeight: 600,
                          color: "#58595B",
                          fontFamily:
                            "work sans",
                        }}
                      >
                        Yes
                      </span>
                    </Grid>
                  </Grid>
                  <Grid container spacing={1}>
                    <Grid item lg={1}>
                      <span
                        style={{
                          fontSize: "14.13px",
                          fontWeight: 600,
                          color: "#58595B",
                          fontFamily:
                            "work sans",
                        }}
                      >
                        Address:
                      </span>
                    </Grid>
                    <Grid item lg={3}>
                      <span
                        style={{
                          fontSize: "14.13px",
                          fontWeight: 600,
                          color: "#58595B",
                          fontFamily:
                            "work sans",
                        }}
                      >
                        7723 Jefferson Davis Highway Arlington, VA 2201
                      </span>
                    </Grid>
                    <Grid item md={2}>
                      <span></span>
                    </Grid>
                    <Grid item lg={1}>
                      <span
                        style={{
                          fontSize: "14.13px",
                          fontWeight: 600,
                          color: "#58595B",
                          fontFamily:
                            "work sans",
                        }}
                      >
                        Fax:
                      </span>
                    </Grid>
                    <Grid item lg={2}>
                      <span
                        style={{
                          fontSize: "14.13px",
                          fontWeight: 600,
                          color: "#58595B",
                          fontFamily:
                            "work sans",
                        }}
                      >
                        (703) 205-7034
                      </span>
                    </Grid>
                    <Grid item lg={1}>
                      <span
                        style={{
                          fontSize: "14.13px",
                          fontWeight: 600,
                          color: "#58595B",
                          fontFamily:
                            "work sans",
                        }}
                      >
                        EPCS:
                      </span>
                    </Grid>
                    <Grid item lg={2}>
                      <span
                        style={{
                          fontSize: "14.13px",
                          fontWeight: 600,
                          color: "#58595B",
                          fontFamily:
                            "work sans",
                        }}
                      >
                        Yes
                      </span>
                    </Grid>
                  </Grid>
                </div>
                <nav class="navbar navbar-expand-lg   navbar-dark theme-color     p-0  ">
                  <a
                    class="navbar-brand  ms-4 fw-bolder"
                    style={{
                      fontSize: "15.14px",
                      fontWeight: 600,
                      fontFamily:
                        "work sans",
                    }}
                    href="#"
                  >
                    Pending Prescriptions
                  </a>
                </nav>

                <div class="d-flex justify-content-left p-2 mobileFlex" style={{ backgroundColor: "white" }}>
                  <div
                    class="btn text-dark rounded-2 theme-font"
                    style={{ width: "max-content", textAlign: "left", marginLeft: "2px", }}
                  >
                    <h6
                      style={{
                        fontSize: "14.13px",
                        fontWeight: 600,
                        color: "#58595B",
                        fontFamily:
                          "work sans",
                      }}
                    >
                      {" "}
                      Prescriber:{" "}
                      <span
                        style={{
                          fontSize: "14.13px",
                          fontWeight: 500,
                          color: "#58595B",
                          fontFamily:
                            "work sans",
                        }}
                      >
                        Tom Collins MD
                      </span>
                    </h6>
                  </div>
                  <div
                    class="btn text-dark rounded-2 theme-font"
                    style={{ width: "400px", textAlign: "left", marginLeft: "2px" }}
                  >
                    <h6
                      style={{
                        fontSize: "14.13px",
                        fontWeight: 600,
                        color: "#58595B",
                        fontFamily:
                          "work sans",
                      }}
                    >
                      {" "}
                      DEA:{" "}
                      <span
                        style={{
                          fontSize: "14.13px",
                          fontWeight: 500,
                          color: "#58595B",
                          fontFamily:
                            "work sans",
                        }}
                      >
                        No DEA Number for WA
                      </span>
                    </h6>
                  </div>
                  <div
                    class="btn text-dark rounded-2 theme-font"
                    style={{ width: "300px", textAlign: "left", marginLeft: "2px" }}
                  >
                    <h6
                      style={{
                        fontSize: "14.13px",
                        fontWeight: 600,
                        color: "#58595B",
                        fontFamily:
                          "work sans",
                      }}
                    >
                      Phone:{" "}
                      <span
                        style={{
                          fontSize: "14.13px",
                          fontWeight: 500,
                          color: "#58595B",
                          fontFamily:
                            "work sans",
                        }}
                      >
                        (234)523-2545
                      </span>
                    </h6>
                  </div>
                  <div
                    class="btn text-dark rounded-2 theme-font"
                    style={{ width: "460px", textAlign: "left", marginLeft: "2px" }}
                  >
                    <h6
                      style={{
                        fontSize: "14.13px",
                        fontWeight: 600,
                        color: "#58595B",
                        fontFamily:
                          "work sans",
                      }}
                    >
                      Address:{" "}
                      <span
                        style={{
                          fontSize: "14.13px",
                          fontWeight: 500,
                          color: "#58595B",
                          fontFamily:
                            "work sans",
                        }}
                      >
                        32 No Way221 Placeville, WA 12345
                      </span>
                    </h6>
                  </div>
                  <div
                    class="btn text-dark rounded-2 theme-font"
                    style={{
                      width: "460px",
                      textAlign: "left",
                      marginLeft: "2px",
                      marginTop: "-5px",
                    }}
                  >
                    <input class="form-check-input p-2" type="checkbox" value="" />
                    <label
                      for=""
                      class="text-secondary ms-3 theme-font"
                      style={{
                        fontSize: "14.13px",
                        fontWeight: 600,
                        color: "#58595B",
                        fontFamily:
                          "work sans",
                        marginTop: "3px",
                      }}
                    >
                      Print one Rx per page:
                    </label>
                  </div>
                </div>
                <div className="prescription-table-wrap" style={{ backgroundColor: "white" }}>
                  <Table className="prescription-table pharmacy-med-table">
                    <thead>
                      <tr>
                        <th style={{ minWidth: "20px" }}>
                          <div className="form-check my-0 ms-5" style={{ padding: "0px" }}>
                            <input
                              className="form-check-input p-2"
                              type="checkbox"
                              value=""
                              checked={true}
                              readOnly
                            />
                            <label
                              htmlFor=""
                              className="text-secondary ms-3 theme-font"
                            ></label>
                          </div>
                        </th>
                        <th>Date Created</th>
                        <th>Medication</th>
                        <th>Amount</th>
                        <th style={{ textAlign: "center" }}>Refills</th>
                        <th style={{ textAlign: "center" }}>Leaflet</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.rows.map((name) => name)}
                    </tbody>
                  </Table>
                </div>
                <div class="mb-3 ms-3 row" style={{ padding: "27px", backgroundColor: "white" }}>
                  <nav
                    class="navbar navbar-dark mt-3 p-0"
                    style={{ marginLeft: "-15px", background: "#e5e5e5" }}
                  >
                    <a class="navbar-brand theme-font ms-4" href="#">
                      <span
                        style={{
                          fontSize: "14.13px",
                          fontWeight: 600,
                          color: "gray",
                          marginLeft: "-8px",
                        }}
                      >
                        Total Medication(s):
                      </span>{" "}
                      <span
                        style={{ fontSize: "12px", fontWeight: 600, color: "gray" }}
                      >
                        {1 + this.state.rows.length}
                      </span>
                    </a>
                  </nav>
                  <div
                    style={{
                      marginLeft: 1230,
                      marginTop: -750,
                      position: "absolute",
                    }}
                  ></div>
                </div>
              </section>
              <div className="row" style={{ marginBottom: "30px" }}>
                {
                  this.props.reactCreative &&
                  <div className="col-md-3  mobileCss mobCenter" style={{ margin: "20px 0" }}>
                    <div className="responsiveMargin" style={{ maxWidth: '300px', minHeight: '250px', }}>
                      <iframe
                        title="iframe"
                        srcDoc={this.props.reactCreative}
                        style={{
                          width: '100%',
                          height: '100%',
                          maxWidth: '100%',
                          minHeight: '250px',
                          marginBottom: "30px"
                        }}
                        frameBorder="0"
                        scrolling="no"
                      />
                    </div>
                  </div>
                }

                <div
                  className={`${this.props.reactCreative ? "col-md-9" : "col-md-12"} text-right pharmacy-action-btns`}
                  style={{
                    marginBottom: "40px",
                    marginTop: "20px",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "0",
                  }}
                >
                  <Button
                    height="fit-content"
                    className="billing-btn-outline billing-btn-wide"
                  >
                    Close
                  </Button>
                  <Medication parentCallback={this.handleCallback} />
                </div>
              </div>
            </div>
          </Grid>
          {
            this.props.verticalCreative &&
            <Grid item md={12} lg={3} xs={12}>
              <div className="pharmacyRight rightIframe mobileCss mobCenter  d-flex justify-content-end">
                <div className='responsiveMargin' style={{ maxWidth: '300px', minHeight: '600px', }}>
                  <iframe
                    title="iframe"
                    srcDoc={this.props.verticalCreative}
                    style={{
                      width: '100%',
                      height: '100%',
                      maxWidth: '100%',
                      minHeight: '600px',
                      marginBottom: "30px"
                    }}
                    frameBorder="0"
                    scrolling="no"
                  />
                </div>
              </div>
            </Grid>
          }

        </Grid>
        <div>
          <Modal
            open={this.state.isOpen}
            onClose={this.handleClose}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ outline: "none !important" }}
            centered
          >
            <div style={this.state.modalStyle} className="responsivePopUp noHeight">
              <h2
                id="simple-modal-title"
                style={{
                  fontSize: "22px",
                  fontWeight: 600,
                  fontFamily:
                    "work sans",
                  textAlign: "center",
                  paddingTop: "60px",
                  position: "relative",
                  paddingBottom: "20px"
                }}
              >
                Prescription Sent
              </h2>
              <Button
                onClick={this.handleClose}
                height="fit-content"
                borderRadius="20px"
                style={{
                  width: "100px",
                  maxWidth: "100px",
                  height: "30px",
                  marginTop: "7px",
                  backgroundImage: "none",
                  backgroundColor: "#D0D2D3",
                  color: "#606060",
                  fontSize: "13.5px",
                  fontWeight: 600,
                  fontFamily:
                    "work sans",
                  textAlign: "center",
                  marginBottom: "60px"
                }}
              >
                Close
              </Button>
            </div>
          </Modal>
        </div>
      </div >
    );
  }
}

Pharmacy.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(useStyles)(Pharmacy);
